import React from "react";
import PropTypes from "prop-types";
import MDInput from "components/MDInput";
import { Grid, TextField, Typography, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { searchBoxStyles } from "utils/pageHeaderStyles";

const MaklumatSearch = ({ search, handleSearchChange, onEdit, onDelete, selectedRow }) => {
  const [controller] = useMaterialUIController();
  const { darkMode, whiteSidenav, transparentSidenav } = controller;
  const shouldApplyStyle =
    (!darkMode && !whiteSidenav && !transparentSidenav) ||
    (darkMode && !transparentSidenav && whiteSidenav);

  return (
    <MDBox sx={searchBoxStyles.container}>
      <Typography variant="h6" fontWeight="bold" mb={1.5}>
        Carian
      </Typography>
      <Grid container spacing={1.5} alignItems="center">
        <Grid item xs={12} md={4} sx={{ mb: 2 }}>
          <MDInput
            label="Nama"
            name="nama"
            size="small"
            value={search.nama}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: (
                <IconButton size="small">
                  <SearchIcon fontSize="small" />
                </IconButton>
              ),
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4} sx={{ mb: 2 }}>
          <MDInput
            label="No KP"
            name="no_kp"
            size="small"
            value={search.no_kp}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: (
                <IconButton size="small">
                  <SearchIcon fontSize="small" />
                </IconButton>
              ),
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4} sx={{ mb: 2 }}>
          <MDInput
            label="Nama Syarikat"
            name="nama_syarikat"
            size="small"
            value={search.nama_syarikat}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: (
                <IconButton size="small">
                  <SearchIcon fontSize="small" />
                </IconButton>
              ),
            }}
            fullWidth
          />
        </Grid>
      </Grid>
  {/* Action buttons removed as requested */}
    </MDBox>
  );
};

MaklumatSearch.propTypes = {
  search: PropTypes.shape({
    nama: PropTypes.string,
    no_kp: PropTypes.string,
    nama_syarikat: PropTypes.string,
  }).isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  selectedRow: PropTypes.object,
};

MaklumatSearch.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
  selectedRow: null,
};

export default MaklumatSearch;
